module.exports = __webpack_public_path__ + "static/img/aboutus_pic.8701ef45.png";